import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Root from './ui/components/root';
import { HashRouter } from "react-router-dom";
import configureStore from './store/store';
import { Auth0ProviderWithNavigate } from "./auth0-provider-with-navigate";

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <HashRouter>
        <Auth0ProviderWithNavigate>
            <Root store={configureStore()} />
        </Auth0ProviderWithNavigate>
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

